import React from "react";
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

import image1 from 'assets/img/hofvijver.jpg'

export default class ContactSection extends React.Component {
  render() {
    return (
      <GridContainer justify="center" spacing={2}>
        <GridItem xs={11} sm={9} md={7}>
          <h2>Contact</h2>
          <p>I am keen on working together with new people, so don’t hesitate to contact me!</p>
          <div class="contact-container">
            <ul>
              <li>mail@izziel.nl</li>
              <li>+316 47588135</li>
              <li>The Hague, The Netherlands</li>
            </ul>
          </div>
        </GridItem>
      </GridContainer>
    );
  }
}